<div [ngClass]="getStatusClass()">
  <i class="fa fa-circle" aria-hidden="true"></i>
  {{'data-integration.api.status.' + getStatusText() | translate}}
</div>
